<template>
  <section class="fluent-quantum">
    <div class="fluent-quantum-sticky">
      <div v-textMotion class="text-intro quantum-text-intro">
        <p class="title">{{ $t('quantum-text-title') }}</p>
        <p class="sub-title">{{ $t('quantum-text-sub-title') }}</p>
        <p class="description">
          {{ $t('quantum-text-description') }}
        </p>
      </div>
      <div class="quantum-phone-main" :class="showQuantumMain ? 'keyVisionMotion' : 'visibility-hidden'">
        <div
          class="quantum-phone-container"
          :class="vm.isMobile ? (showPhoneGif ? 'keyVisionMotion' : 'visibility-hidden') : ''"
        >
          <img
            v-if="!vm.isMobile || (vm.isMobile && showPhoneGif && lang !== 'zh')"
            v-lazy="require('../../assets/fluent/phone-model.png')"
            alt="ColorOS 11"
            class="quantum-phone-img"
          />
          <lazy-component v-if="!vm.isMobile" ref="phoneVideoComponent">
            <video muted="muted" preload="metadata" :class="lang === 'zh' ? 'quantum-phone-video' : ''">
              <source
                :src="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}fluent/quantum-phone-video.mp4`)"
                type="video/mp4"
              />
            </video>
          </lazy-component>
          <img
            v-if="vm.isMobile && showPhoneGif && lang !== 'zh'"
            v-lazy="require('../../assets/fluent/quantum-phone-video.gif')"
            alt="ColorOS 11"
            class="quantum-phone-gif"
          />
          <lazy-component
            v-if="vm.isMobile && lang === 'zh'"
            ref="phoneVideoComponent"
            class="quantum-phone-mobile-container"
            :class="{
              'quantum-phone-svg-hide': mobileVideoPlaying,
              'quantum-phone-svg-black': mobileVideoHasNotPlaying
            }"
            @show="mobileVideoShow"
          >
            <video
              muted="muted"
              preload="meta"
              poster="../../assets/zh/fluent/quantum-phone-video-poster.jpg"
              x5-playsinline
              webkit-playsinline
              playsinline
              x5-video-player-type="h5"
              x5-video-orientation="portraint"
              :src="require(`../../assets/zh/fluent/quantum-phone-video${vm.isMobile ? '-mobile' : ''}.mp4`)"
            ></video>
            <img src="../../assets/zh/fluent/quantum-phone-video-poster.jpg" alt="ColorOS 11" />
          </lazy-component>
          <play-button-text
            v-if="vm.isMobile && lang === 'zh'"
            ref="playButtonText"
            target-video=".quantum-phone-mobile-container video"
          />
        </div>
        <div v-if="!vm.isMobile" class="quantum-cubic-container">
          <span class="quantum-cubic-axis-top">{{ $t('quantum-phone-fiction') }}</span>
          <span class="quantum-cubic-axis-bottom">{{ $t('quantum-phone-time') }}</span>
          <lazy-component ref="cubicVideoComponent">
            <video muted="muted" preload="metadata">
              <source src="../../assets/fluent/quantum-cubic-video.mp4" type="video/mp4" />
            </video>
          </lazy-component>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import Controller from '../../util/scrollMagic';
import PlayButtonText from '@/components/PlayButtonText';

export default {
  inject: ['vm', 'lang'],
  components: {
    PlayButtonText
  },
  data() {
    return {
      // textWOWOffset: window.innerWidth <= 737 ? 100 : 0.5 * 300,
      showQuantumMain: false,
      showPhoneGif: false,
      mobileVideoPlaying: false,
      mobileVideoHasNotPlaying: true
    };
  },
  mounted() {
    this.resizeHandler();
    window.addEventListener('resize', this.resizeHandler);
  },
  methods: {
    initScroll() {
      this.scene = new ScrollMagic.Scene({
        triggerElement: '.quantum-phone-main',
        triggerHook: 1,
        offset: window.innerWidth <= 737 ? 100 : 0.3 * window.innerHeight
      })
        .addTo(Controller)
        .on('enter', () => {
          if (!this.showQuantumMain) {
            this.showQuantumMain = true;
            if (!this.vm.isMobile) this.playVideo();
          }
          if (this.vm.isMobile) {
            // this.showPhoneGif = true;
            this.loadMobileGif();
          }
        });

      new ScrollMagic.Scene({
        triggerElement: '.quantum-phone-main',
        triggerHook: 1,
        offset: window.innerWidth <= 737 ? 0 : 0.5 * window.innerHeight
      })
        .addTo(Controller)
        .on('leave', () => {
          this.showPhoneGif = false;
        });

      setTimeout(() => {
        if (this.scene.progress() > 0) {
          this.showQuantumMain = true;
          if (!this.vm.isMobile) this.playVideo();
        }
      }, 1000);
    },
    loadMobileGif() {
      let img = new Image();
      img.src = require('../../assets/fluent/quantum-phone-video.gif');
      img.className = 'quantum-phone-gif';
      img.onload = () => {
        this.showPhoneGif = true;
      };
    },
    resizeHandler() {
      if (!this.scene) {
        this.initScroll();
      } else {
        this.scene.offset(window.innerWidth <= 737 ? 100 : 0.5 * window.innerHeight);
      }
    },
    playVideo() {
      setTimeout(() => {
        if (this.$refs.phoneVideoComponent.$el && this.$refs.phoneVideoComponent.$el.children[0]) {
          this.$refs.phoneVideoComponent.$el.children[0].play();
          this.$refs.cubicVideoComponent && this.$refs.cubicVideoComponent.$el.children[0].play();
        } else {
          this.playVideo();
        }
      }, 1300);
    },
    mobileVideoShow() {
      setTimeout(() => {
        if (this.$refs.phoneVideoComponent.$el && this.$refs.phoneVideoComponent.$el.children) {
          this.$refs.playButtonText.init();
        } else {
          this.videoShow();
        }
      }, 100);
    }
  }
};
</script>
